<template>
  <div id="app">
    <transition appear name="fade">
      <router-view />
    </transition>
    <Spinner v-if="isSpinnerLoading()"></Spinner>
  </div>
</template>
<script>

import Spinner from "@/components/base.component/Spinner.vue";

export default {
  components: {
    Spinner
  },
  data() {
    return {
      message: {
        title: '',
        message: ''
      }
    };
  },
  watch: {
    $route(to, from) {
      const event = {
        event: 'dcv_demo_vpv',
        path: `/radio-system-interactive-presentation${to.fullPath}`
      };

      this.logGaEvent(event, to);
    }
  },

  mounted() {
    const event = {
      event: 'dcv_demo_start',
      dcvTimestampStart: Date.now(),
    };

    this.logGaEvent(event, this.$route);
  },
  methods: {
    checkBrowser() {
      var isSafari = window.safari !== undefined;
      var browser;
      var bool = false;

      if (isSafari) {
        (browser = 'safari'), (bool = true);
      }

      /* Feature checking  */
      if (window.document.documentMode) {
        (browser = 'internet explorer'), (bool = true);
      }
      if (bool) {
        (this.message.title = `Page not optimized for ${browser} `),
          (this.message.body =
            'Please use edge, firefox or chrome. Chrome is the recommended browser');
        this.gateOpen = true;
      }
    },
    isSpinnerLoading() {
      return this.$store.state.isSpinnerLoading;
    },
    logGaEvent(event, routeTo) {
      const extendedEvent = {
        ...event, 
        dcvAssetName: routeTo?.params?.product ?? 'Ericsson Radio system Interactive Presentation',
        demo_code: `${new Date().getFullYear() % 100}.13`,
        organisation: 'BNEW'
      };

      dataLayer.push(extendedEvent);
    }
  }
};
</script>
<style lang="less">
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
@import '~@eds/vanilla/font/font-dark.css';
@import '~@eds/vanilla/eds.less';

a {
  outline: none !important;
  text-decoration: none !important;
}
/* ELEMENTS */
p {
  margin: 0;
}
ul {
  margin: 0;
  padding: 0;
}
h1 {
  font-size: 3.75vw;
  line-height: 1.2;
  letter-spacing: -0.036em;
  font-weight: 300;
}
h2 {
  font-size: 2.91vw;
  line-height: 1;
  letter-spacing: -0.024em;
  font-weight: 300;
}
h3 {
  font-size: 1.45vw;
  line-height: 1;
  letter-spacing: -0.012em;
  font-weight: @weight-medium;
}
h4 {
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.006em;
  font-weight: 300;
}
h5 {
  font-size: 14px;
  line-height: 1;
  letter-spacing: -0.006em;
  font-weight: 300;
}
h6 {
  font-size: 14px;
  line-height: 1;
  opacity: 80%;
  color: #767676;
  letter-spacing: -0.006em;
}
/* Transitions */
/* Transition of image */
.fade-long-enter-active .fade-long-leave-active {
  transition: opacity 0s ease-out forward;
}
.fade-long-enter,
.fade-long-leave-to {
  opacity: 0;
}
.fade-long-enter-active {
  transition: opacity 0.5s;
}

.fade-enter-active .fade-leave-active {
  transition: opacity 0s ease-out forward;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
/* Generela */
.autow {
  width: auto;
}
.absolute {
  position: absolute;
}
.bg-layer0 {
  background-color: @layer0;
}
.bg-layer1 {
  background-color: @layer1;
}
.bg-layer2 {
  background-color: @layer2;
}

.floating-text-boxes {
  background-color: @layer2;
}
.clickable {
  cursor: pointer;
}
.fullscreen {
  width: 100%;
  height: 100%;
}
body,
html {
  margin: 0px;
  touch-action: none;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
#app {
  width: 100%;
  height: 100%;
}
.fade-enter-active {
  transition: opacity 1s;
}

/* EDS */
/* Hardcoded these because i could not find without the "light/dark/" prefix*/

.text-sm {
  font-size: 12px;
}
.text-default {
  font-size: 14px;
}
.text-lg {
  font-size: 16px;
}
.text-lgPlus {
  font-size: 20px;
}
.text-md {
  font-size: 24px;
}
.text-xl {
  font-size: 28px;
}
.text-xxl {
  font-size: 36px;
}
.text-xxxl {
  font-size: 44px;
}
.icon-general {
  cursor: pointer;
  width: 1.4rem;
  height: 1.4rem;
}
.bold {
  font-weight: @weight-bold;
}
/* Smartphones (portrait and landscape) ----------- */
@media @desktop {
  html,
  body {
    .text-lg;
  }
  .dark .card .header .left .title {
    .bold;
    .text-lg;
  }
}

/* Desktops and laptops ----------- */
@media @larger {
  html,
  body {
    .text-lg;
  }
  .dark .card .header .left .title {
    .bold;
    .text-lg;
  }
}

@EvenLarger: ~'only screen and (min-width: 135em)';

@media @EvenLarger {
  html,
  body {
    .text-lgPlus;
  }
  .dark .card .header .left .title {
    .bold;
    .text-lgPlus;
  }
}
@4k: ~'only screen and (min-width: 3840px)';

@media @4k {
  html,
  body {
    .text-xxxl;
  }
  .dark .card .header .left .title {
    .bold;
    .text-xxxl;
  }
}
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}
.dark input[type='checkbox']:focus + label::before {
  outline: none;
  outline-offset: 0px;
}
</style>
